import React from "react";

function WebWalletDevS() {
  return (
    <>
      <div
        className="about-style-three-area default-padding bg-gray bg-cover"
        style={{ background: "url(assets/img/shape/banner-16.html)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h4 className="sub-title">AI writing assistant</h4>
              <h2 className="title split-text-right split-text-in-right">
                Web3 Wallet Development Service by Xeer Technology
              </h2>
              <p>
                Xeer Technology offers cutting-edge Web3 wallet development
                services, providing businesses with secure, scalable, and
                user-friendly wallets that support seamless interaction with
                decentralized applications (dApps) and blockchain networks. Our
                solutions are designed to give users full control over their
                private keys, ensuring maximum security and privacy.
              </p>
              <p>
                We integrate multi-currency support, advanced encryption,
                KYC/AML compliance, and cross-platform compatibility, creating a
                versatile wallet that can handle transactions and engage with
                the broader Web3 ecosystem. From DeFi and NFTs to smart contract
                interaction, our Web3 wallets are optimized for performance,
                security, and a superior user experience.
              </p>
              <a className="btn btn-style-one" href="#">
                Know more
              </a>
            </div>
            <div className="col-lg-6">
              <div className="about-style-three-thumb">
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/dashboard-4.jpg"
                  alt="Image Not Found"
                />
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/1.gif"
                  alt="Image Not Found"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WebWalletDevS;
